<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import FilterSelectMultiple from '@/onenetwork/components/filter/FilterSelectMultiple.vue'
import FilterTagInput from '@/onenetwork/components/filter/FilterTagInput.vue'
import FilterDateRange from '@/onenetwork/components/filter/FilterDateRange.vue'
import { Button } from '@/components/ui/button'
import { Icon } from '@iconify/vue'
import AccountPicker from '@/onenetwork/components/account_picker/AccountPicker.vue'
import ObjectPicker from '@/onenetwork/components/object_picker/ObjectPicker.vue'
import { regions } from '@/onenetwork/constants/onenetwork.regions.const'
import { numHelper } from '@/utils/numHelper'
import WardComp from '@/onenetwork/components/filter/WardComp.vue'
const props = defineProps({
  filter: {
    type: Object
  },
  disableReset: {
    type: Boolean,
    default: false
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  errors: {
    type: Object,
    default: () => ({})
  }
})
const handleValidFilter = (data: any) => {
  if(!data || data.length === 0) return []
  const _newVal = data.map((item: any) => {
    if(['select-multiple', 'taginput', 'date-range', 'price-range'].includes(item.type)) {
      // console.log(95, item.value)
      if(typeof item.value == 'string') item.value = [];
    }
    return item;
  })
  return _newVal
}

const filterData = ref(handleValidFilter(props.filter))
const emit = defineEmits(['update:filter', 'reset:filter'])
const readOnly = computed(() => props.readOnly)
const _regions = regions.map((item: any) => {
  return {
    id: item.id,
    name: item.name,
    select: false
  }
})
const _districts = ref([]);
const selectedRegion = ref([]);
const selectedDistrict = ref([]);

const handleUpdateAccount = (vals: any) => {

}

const getDistricts = (regionId: string) => {
  const region = regions.find((item: any) => item.id === regionId)
  return region?.children.map((item: any) => {
    return {
      ...item,
      select: false
    }
  })
}

const handleUpdateRegion1 = (vals: any) => {

  selectedRegion.value = vals;

  // Reset district in all cases: when removing region or selecting a different one
  _districts.value = []
  selectedDistrict.value = [];
  const districtFilter = filterData.value?.find((item: any) => item.type === 'region-level-2')
  if (districtFilter) {
    districtFilter.value = []
  }

  // If there's a selected region, load its districts
  if (vals && vals.length > 0) {
    const _get = getDistricts(vals[0].id);
    _districts.value = _get;
  }
}

const handleUpdateRegion2 = (vals: any) => {

  selectedDistrict.value = vals;
}

const handleApplyFilter = () => {
  emit('update:filter', filterData.value)
}

const handleResetFilter = (e: any) => {
  // Reset all filter values to empty
  filterData.value = filterData.value.map((item: any) => ({...item, value: ''}))
  emit('reset:filter')
}



watch(props.filter, (newVal: any, oldVal: any) => {
  filterData.value = handleValidFilter(newVal);
}, {immediate: true, deep: true})

</script>

<template>
  <div class="filter-list positionFixed">
<!--    <div class="filter-list__header">-->
<!--      <h2>Bộ lọc</h2>-->
<!--    </div>-->
    <div class="filter-list__content">

      <div class="filter-item" v-for="(item, index) in filterData" :key="`filterItem${index}`">
        <label>{{item.label}}</label>
        <div class="filter-control">
          <template v-if="item.type === 'text'">
            <input :readonly="readOnly" :type="item.type" :placeholder="item.placeholder" v-model="item.value" />
          </template>
          <template v-if="item.type === 'select-single'">
            <select :readonly="readOnly" v-model="item.value">
              <option v-for="(option, idx) in item.options" :key="`optionItem${idx}`" :value="option.value">{{ option.label }}</option>
            </select>
          </template>
          <template v-if="item.type === 'select-multiple'">
            <filter-select-multiple :read-only="readOnly" v-model="item.value" :options="item.options" />
          </template>
          <template v-if="item.type === 'taginput'">
            <filter-tag-input :read-only="readOnly" v-model="item.value" :options="item.options" />
          </template>
          <template v-if="item.type === 'date-range'">
            <filter-date-range :read-only="readOnly" v-model="item.value" :options="item.options" :placeholder="item.placeholder"/>
          </template>
          <template v-if="item.type === 'month-picker'">
            <div class="filter-date-month-picker">
              <DatePicker :read-only="readOnly" v-model="item.value" view="month" dateFormat="yy-mm" />
            </div>
          </template>
          <template v-if="item.type === 'account-selector'">
            <AccountPicker :read-only="readOnly" :placeholder="item.placeholder" :default_filter_params="{}" :multiple="true" v-model="item.value" @update:selected="handleUpdateAccount"/>
          </template>
          <template v-if="item.type === 'account-bo-selector'">
            <AccountPicker :read-only="readOnly" :placeholder="item.placeholder" type="bo" :default_filter_params="{}" :multiple="true" v-model="item.value" @update:selected="handleUpdateAccount"/>
          </template>
          <template v-if="item.type === 'account-broker-selector'">
            <AccountPicker :read-only="readOnly" :placeholder="item.placeholder" type="broker" :default_filter_params="{}" :multiple="true" v-model="item.value" @update:selected="handleUpdateAccount"/>
          </template>
          <template v-if="item.type === 'region-level-1'">
            <div class="flex flex-col w-full">
              <ObjectPicker
                :read-only="readOnly"
                :placeholder="item.placeholder"
                :multiple="false"
                v-model="item.value"
                key_field="id"
                display_field="name"
                query-field="name"
                api-url=""
                :data="_regions"
                @update:selected="handleUpdateRegion1"
              />
              <span v-if="props.errors?.province_id" class="text-[11px] text-red-500 mt-1">{{ props.errors.province_id }}</span>
            </div>
          </template>
          <template v-if="item.type === 'region-level-2'">
            <div class="flex flex-col w-full">
              <ObjectPicker
                :read-only="readOnly"
                :placeholder="item.placeholder"
                :multiple="false"
                v-model="item.value"
                key_field="id"
                display_field="name"
                query-field="name"
                api-url=""
                :data="_districts"
                :display-comp="WardComp"
                @update:selected="handleUpdateRegion2"
              />
              <span v-if="props.errors?.district_id" class="text-[11px] text-red-500 mt-1">{{ props.errors.district_id }}</span>
            </div>
          </template>
          <!-- price range -->
          <template v-if="item.type === 'price-range'">
            <div class="flex gap-2">
              <div>
                <InputNumber :readonly="readOnly" :placeholder="item.placeholder" v-model="item.value.from" class="form-control w-full" inputId="minmax-buttons" suffix=" đ" mode="decimal" locale="vi-VN" :min="0" :max="10000000000000" fluid />
                <span class="font-italic text-[12px] text-red-500 mt-1">{{numHelper(item.value.from).numberToVietnameseText({unit: 'đồng'})}}</span>
              </div>
              <div>
                <InputNumber :readonly="readOnly" :placeholder="item.placeholder" v-model="item.value.to" class="form-control w-full" inputId="minmax-buttons" suffix=" đ" mode="decimal" locale="vi-VN" :min="0" :max="10000000000000" fluid />
                <span class="font-italic text-[12px] text-red-500 mt-1">{{numHelper(item.value.to).numberToVietnameseText({unit: 'đồng'})}}</span>
              </div>
            </div>
          </template>
          <!-- end price range -->
        </div>
      </div>
      <div class="filter-item flex !flex-row gap-2 items-center" v-if="!readOnly">
        <button class="btn-apply-filter mt-6" type="button" @click="handleApplyFilter">
          <span class="icon"><Icon icon="iconamoon:search"/></span>
          {{$t('filter.button.apply')}}
        </button>
        <span v-if="!props.disableReset" @click="handleResetFilter" class="mt-6 text-[11px] hover:text-[#ff6a6a] text-[#c9c9c9] cursor-pointer">Reset bộ lọc</span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
